import type { ReceiptTemplate } from '../schema';

export const salvationArmyTemplate: ReceiptTemplate = {
  id: 'salvation-army',
  name: 'Salvation Army Receipt',
  brand: 'SALVATION ARMY',
  description: 'Salvation Army donation receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'sa-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'THE SALVATION ARMY',
        businessNameFontSize: 14,
        addressLines: ['DONATION RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sa-donor',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'donor', label: 'Donor:', value: 'John Doe' },
          { id: 'receipt', label: 'Receipt #:', value: 'SA-847291034' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'location', label: 'Location:', value: 'Monsterville' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sa-items',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'DONATION TYPE: Household Items\n\nITEMS DONATED:\n- Clothing (2 bags)\n- Kitchenware (1 box)\n- Books (1 box)', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'sa-value',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'value', label: 'EST. VALUE', value: '150.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sa-tax',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'TAX-DEDUCTIBLE DONATION\nEIN: 58-0660607\n\nRetain for tax purposes.', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'sa-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'DOING THE MOST GOOD\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

